import React from 'react';
import type { ColumnsBlock } from '@staty/shared/schemas/block';
import { columnsTemplate } from '@staty/shared/components/BlockRenderer';
import type { EntityRef } from '../editorStore';
import BlockList from '../BlockList';

/**
 * Columns block: renders the SAME shared grid classes the public page uses
 * (.staty-block--columns / .staty-block-column from blockContent.css), with
 * a nested editable BlockList per cell. Column count (2–4) is changed in the
 * settings panel.
 *
 * NOTE: circular import with BlockList is intentional and safe — both
 * modules only reference each other at render time, never during module
 * evaluation.
 */

interface Props {
  block: ColumnsBlock;
  entity: EntityRef;
  leagueName: string;
}

export default function ColumnsBlockEditor({ block, entity, leagueName }: Props) {
  return (
    <div
      className="staty-block staty-block--columns"
      data-cols={block.columns.length}
      // Same custom property the shared renderer sets — the canvas must
      // compose at the exact ratios the public page will.
      style={{ ['--staty-cols' as string]: columnsTemplate(block) }}
    >
      {block.columns.map((col) => (
        <div key={col.id} className="staty-block-column canvas-column">
          <BlockList
            entity={entity}
            blocks={col.blocks}
            leagueName={leagueName}
            colAddr={{ blockId: block.id, columnId: col.id }}
          />
          {col.blocks.length === 0 && (
            <p className="canvas-column__empty">Empty column: use “+” to add content</p>
          )}
        </div>
      ))}
    </div>
  );
}
